<template>
  <div class="card p-3 user-list-table">
    <TableViewBo :columns="tableColumns" :items="items" :pagination="pagination" :sort-field="sortField"
      :sort-direction="sortDirection" :show-search="false" :has-actions="false" :selectable="true"
      :all-selected="allSelected" @select-all="toggleSelectAll" @page-change="$emit('page-change', $event)"
      @sort="$emit('sort', $event)">

      <template #new="{ item }">
        <span class="status-dot no-ellipsis" :class="item.active ? 'active' : 'inactive'">
        </span>
      </template>
      <!-- Checkbox per riga -->
      <template #selected="{ item }">
        <input type="checkbox" :value="item.id" v-model="selectedUsers" @change="onSelectionChange">
      </template>

      <!-- ID -->
      <template #id="{ item }">
        <span class="fw-bold">{{ item.id }}</span>
      </template>

      <!-- Cognome -->
      <template #surname="{ item }">
        <span>{{ item.surname }}</span>
      </template>

      <!-- Nome -->
      <template #name="{ item }">
        <span>{{ item.name }}</span>
      </template>

      <!-- Email -->
      <template #email="{ item }">
        <span>{{ item.email }}</span>
      </template>

      <!-- Ruolo -->
      <!--<template #role="{ item }">
        <span>{{ item.roles[0]?.description || '-' }}</span>
      </template>-->


      <template #actions="{ item }">

        <button  v-if="item.user_type_code !== 'S'" class="btn btn-success btn-sm me-1" title="Invia reset password"
          @click="$emit('reset-password', item.id)">
          <i class="bi bi-envelope-fill"></i>
        </button>

        <button  v-if="item.user_type_code !== 'S'" class="btn btn-danger btn-sm me-1" title="Gestisci permessi"
          @click="$emit('manage-permissions', item.id)">
          <i class="bi bi-lock-fill"></i>
        </button>

        <button class="btn btn-primary btn-sm me-1" title="Modifica anagrafica" @click="$emit('edit-user', item.id)">
          <i class="bi bi-person-fill"></i>
        </button>

        <button v-if="canManageRoles || (!canManageRoles && !item.active)" class="btn btn-warning btn-sm" title="Abilita/Disabilita utente"
          @click="$emit('toggle-active', item.id)">
          <i class="bi bi-arrow-repeat"></i>
        </button>
      </template>

      <template #empty>
        Nessun utente trovato.
      </template>
    </TableViewBo>
  </div>
</template>

<script>
import TableViewBo from '../../../../components/common/TableViewBo.vue';

export default {
  name: 'UserListTable',
  components: { TableViewBo },
  props: {
    items: { type: Array, required: true },
    pagination: Object,
    sortField: String,
    sortDirection: String
  },
  data() {
    return {
      selectedUsers: [],
      allSelected: false
    };
  },
  watch: {
    selectedUsers(newVal) {
      this.allSelected = newVal.length === this.items.length && this.items.length > 0;
    },
    items: {
      immediate: true,
      handler() {
        this.selectedUsers = [];
        this.allSelected = false;
      }
    }
  },
  computed: {
    canManageRoles(){
      return this.$root.user?.permissions?.includes('manage-roles')
    },
    tableColumns() {
      return [
        { key: 'new', label: '', width: '5%' },
        { key: 'selected', label: '', width: '3%' },
        { key: 'id', label: 'ID', sortable: true, width: '5%' },
        { key: 'surname', label: 'COGNOME', sortable: true, width: '15%' },
        { key: 'name', label: 'NOME', sortable: true, width: '15%' },
        { key: 'email', label: 'E-MAIL', sortable: true, width: '25%' },
        //{ key: 'role', label: 'RUOLO', sortable: true, width: '15%' },
        { key: 'actions', label: 'AZIONI', width: '17%' }
      ];
    }
  },
  methods: {
    onSelectionChange() {
      this.allSelected = this.selectedUsers.length === this.items.length;
      this.$emit('update:selected-users', this.selectedUsers);
    },
    toggleSelectAll(checked) {
      this.allSelected = checked;
      this.selectedUsers = checked ? this.items.map(u => u.id) : [];
      this.$emit('update:selected-users', this.selectedUsers);
    }
  }
};
</script>
<style scoped>
.user-list-table ::v-deep(table) {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}

.user-list-table ::v-deep(table th),
.user-list-table ::v-deep(table td) {
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-dot.active {
  background-color: green;
}

.status-dot.inactive {
  background-color: red;
}

.no-ellipsis {
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: normal !important;
}
</style>